import React from "react";
import Section from "../components/Section";
import ResumePDF from "../assets/Dhoni_Ambalika_sde.pdf";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import { homeDPageDetails } from "./constants";

const SocialIcon = ({ href, icon }) => {
  return (
    <a
      className="social-icon"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      {icon}
    </a>
  );
};

export default function Home() {
  const icons = [
    {
      href: "https://www.linkedin.com/in/ambalika-dhoni-a22224183",
      icon: <FaLinkedinIn />,
    },
    {
      href: "https://github.com/Adhoni",
      icon: <FaGithub />,
    },
  ];

  return (
    <Section id="about">
      <div className="row justify-content-between">
        <div className="col-md-6 order-last order-lg-first" data-aos="fade-up">
          <h1 className="mb-0 mobile-name" style={{paddingTop: "2vw", fontSize: "6rem" }}>
            Dhoni
            <span
              className="text-primary"
              style={{ paddingLeft: "2vw", fontSize: "6rem" }}
            >
            Ambalika
            </span>
          </h1>

          <div className="subheading mb-3">
            <a
              href="mailto:ambalika.dhoni@stonybrook.edu"
              className="home-mail"
            >
              ambalika.dhoni@stonybrook.edu
            </a>
          </div>
        </div>
        <div className="col-md-3 mb-5 mb-lg-0" data-aos="fade-up"></div>
      </div>

      <p className="lead mb-4">{homeDPageDetails?.details}</p>

      <div className="btn-group mb-5">
        <button
          className="btn btn-primary btn-custom py-2 px-5 CV-Button"
          type="submit"
          onClick={() => window.open(ResumePDF)}
        >
          Download CV
        </button>
      </div>

      <div className="social-icons">
        {icons.map(({ href, icon }, index) => (
          <SocialIcon href={href} icon={icon} key={index} />
        ))}
      </div>
    </Section>
  );
}
